import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  itemSku: null,
  loading: false,
  error: null,
};

const getItemSkuSlice = createSlice({
  name: "getItemSku",
  initialState,
  reducers: {
    fetchItemSkuStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchItemSkuSuccess: (state, action) => {
      state.loading = false;
      state.itemSku = action.payload;
    },

    fetchItemSkuFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchItemSkuStart,
  fetchItemSkuSuccess,
  fetchItemSkuFailure,
} = getItemSkuSlice.actions;

export default getItemSkuSlice.reducer;